module.exports = __webpack_public_path__ + "static/media/Logo-N.0cdb0101.PNG";